import { render, staticRenderFns } from "./PopTableSelect.vue?vue&type=template&id=4577a1fa&scoped=true&"
import script from "./PopTableSelect.vue?vue&type=script&lang=js&"
export * from "./PopTableSelect.vue?vue&type=script&lang=js&"
import style0 from "./PopTableSelect.vue?vue&type=style&index=0&id=4577a1fa&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4577a1fa",
  null
  
)

export default component.exports